export const FooterMenu = [
  {
    items: [
      {
        label: 'Noticias',
        url: 'https://es.benzinga.com/news',
      },
      {
        label: 'Trading',
        url: 'https://es.benzinga.com/news/usa/trading/',
      },
      {
        label: 'Acciones de EE.UU.',
        url: 'https://es.benzinga.com/news/usa/stocks/',
      },
      {
        label: 'Criptomonedas',
        url: 'https://es.benzinga.com/crypto/',
      },
      {
        label: 'Shiba Inu',
        url: 'https://es.benzinga.com/crypto/shibainu/',
      },
    ],
    label: 'Noticias',
  },
  {
    items: [
      {
        label: 'Licencias y Sindicación',
        url: 'https://es.benzinga.com/contacto/',
      },
      {
        label: 'Contenido Patrocinado',
        url: 'https://es.benzinga.com/contacto/',
      },
      {
        label: 'Publicar un Anuncio',
        url: 'https://es.benzinga.com/contacto/',
      },
      {
        label: 'Solicitar un Kit de Medios',
        url: 'https://es.benzinga.com/contacto/',
      },
      {
        label: 'Contacto',
        url: 'https://es.benzinga.com/contacto/',
      },
    ],
    label: 'SOCIO/CONTRIBUIDOR',
  },
  {
    items: [
      {
        label: 'Benzinga Estados Unidos',
        url: 'https://www.benzinga.com/',
      },
      {
        label: 'Benzinga Corea',
        url: 'https://kr.benzinga.com/',
      },
      {
        label: 'Benzinga Japón',
        url: 'https://jp.benzinga.com/',
      },
      {
        label: 'Benzinga Italia',
        url: 'https://it.benzinga.com/',
      },
      {
        label: 'Benzinga España',
        url: 'https://es.benzinga.com/',
      },
      {
        label: 'Benzinga India',
        url: 'https://in.benzinga.com//',
      },
    ],
    label: 'BENZINGA GLOBAL',
  },
];

export const FooterCopyRightLinks = [
  {
    label: 'Politica de privacidad',
    url: 'https://es.benzinga.com/privacy-policy/',
  },
  {
    label: 'Terms of Use',
    url: '#',
  },
  {
    label: 'Accessibility',
    url: '#',
  },
];
